import { render, staticRenderFns } from "./ToolsAndServices.vue?vue&type=template&id=3bbee320&lang=pug"
import script from "./ToolsAndServices.vue?vue&type=script&lang=ts"
export * from "./ToolsAndServices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports